// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { ClientActions, ClientActionTypes } from '../_actions/client.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Client } from '../_models/client.model';

// tslint:disable-next-line:no-empty-interface
export interface ClientsState extends EntityState<Client> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedClientId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Client> = createEntityAdapter<Client>();

export const initialClientsState: ClientsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedClientId: undefined,
  showInitWaitingMessage: true,
});

export function clientsReducer(state = initialClientsState, action: ClientActions): ClientsState {
  switch (action.type) {
    case ClientActionTypes.ClientsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedClientId: undefined,
      };
    case ClientActionTypes.ClientsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case ClientActionTypes.ClientCreated:
      return adapter.addOne(action.payload.client, {
        ...state,
        lastCreatedClientId: action.payload.client.id,
      });
    case ClientActionTypes.ClientUpdated:
      return adapter.updateOne(action.payload.partialClient, state);
    case ClientActionTypes.ClientDeleted:
      return adapter.removeOne(action.payload.id, state);
    case ClientActionTypes.ClientsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case ClientActionTypes.ClientsPageLoaded: {
      return adapter.addMany(action.payload.clients, {
        ...initialClientsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case ClientActionTypes.ThrowClientError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case ClientActionTypes.FireClientSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getClientState = createFeatureSelector<ClientsState>('clients');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
